<!--
 - Author : 003.
 - Date   : 2019/6/4.
 - File   : zzYC.资证异常
 -->

<template>
  <div class="relevant-zz">
    <div class="title">
      <img src="../../assets/images/shitang/more.png"
          style="float: right;cursor: pointer;"
          v-if="finalPicList.length>0"
          @click="showMore">
    </div>
    <div>
      <el-carousel :height="state===1?'115px':'150px'" :indicator-position="finalPicList.length>1?'outside':'none'"
          :arrow="finalPicList.length>1?'hover':'never'" v-if="finalPicList&&finalPicList.length>0">
        <el-carousel-item v-for="(item, index) in finalPicList" :key="index">
          <el-row style="text-align: center">
            <el-col :span="12" v-for="(img, i) in item" :key="i">
              <div :class="['pic', state===1?'':'pic1']" @click="showPic(imgUrl+img.fileId)">
                <img :src="img?(imgUrl+img.fileId):imgPic1"
                  alt="">
              </div>
              <p>{{img.name}}</p>
            </el-col>
          </el-row>
        </el-carousel-item>
      </el-carousel>
      <div class="no-the-data" :style="{minHeight: state===1?'95px':'140px'}"
          v-if="finalPicList&&finalPicList.length===0">
        <div>
          <i class="iconfont icon-mingxi dzi" style="font-size: 40px"></i>
          <p>该食堂暂无相关资证</p>
        </div>
      </div>
      <transition name="slide-left-fade">
        <res-Info class="zz-pop" :resInfo="resInfo" v-show="resInfo.resShow"></res-Info>
      </transition>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'zzYC',
    data () {
      return {
        deptId: this.$route.query.deptId,
        imgUrl: this.$store.getters.fileApi,
        imgPic1: require('../../assets/images/index/xkz.jpg'),
        finalPicList: [],
        tmpPicList: [],
        resInfo: {
          theTitle: '',
          theState: '0',
          resShow: false,
          licenseInfo: {},
          insuranceInfo: {}
        }
      }
    },
    props: {
      contractorId: {},
      contractorName: {},
      state: {},
      status: {}
    },
    mounted () {
      this.$nextTick(() => {
        document.addEventListener('click', e => {
          if (e.target.className === 'point') {
            this.resInfo.resShow = false
          }
        })
      })
    },
    watch: {
      contractorId() {
        this.tmpPicList = []
        this.finalPicList = []
        let resShow = this.resInfo.resShow ? this.resInfo.resShow : false
        this.resInfo = {
          theTitle: this.contractorName,
          theState: this.status,
          resShow: resShow,
          licenseInfo: {},
          insuranceInfo: {}
        }
        this.init()
      }
    },
    methods: {
      /**
       * @Description: 初始化
       * @author wanghongling
       * @createDate 2019/12/4
       */
      async init () {
        await this.getLicenseInfo(this.contractorId)
        await this.getBusinesslicense(this.contractorId)
        await this.getInsuranceInfo(this.contractorId)
        if (Object.keys(this.resInfo.licenseInfo).length === 0 && Object.keys(this.resInfo.insuranceInfo).length === 0 && !this.resInfo.businesslicense) {
          this.resInfo.resShow = false
        }
        console.log('初始化this.tmpPicList', this.tmpPicList)
        for (let i = 0; i < this.tmpPicList.length; i += 2) {
          this.finalPicList.push(this.tmpPicList.slice(i, i + 2))
        }
      },
      /**
       * 显示更多相关资质
       * @author wanghongling
       * @createTime 2019-07-19
       */
      showMore () {
        this.resInfo.resShow = !this.resInfo.resShow
        if (this.resInfo.resShow) this.init()
      },
      /**
       * 显示查看图片框
       * @author: whl
       * @createDate: 2019/6/4
       * @param item 图片信息
       * @return {Object}
       */
      showPic (item) {
        this.$superMessage('查看图片', '', {imgPic: item, btnShow: false}).then(() => {
          // do sth
        }).catch(() => {
          // do sth
        })
      },
      /**
       * 获取许可证信息
       * @author wanghongling
       * @createTime 2019/06/20
       */
      getLicenseInfo (orgId) {
        return this.$request.pcLicenseInfoGet({orgId: orgId}).then(res => {
          console.log('获取许可信息', res)
          if (!this.$utils.isEmptyObject(res)) {
            let arry = {
              name: '食品经营许可证',
              fileId: res.licenseInfoResultApiModel.fileId[0]
            }
            this.tmpPicList.push(arry)
            this.resInfo.licenseInfo = res
          }
        }).catch(e => {
          console.error(e)
        // this.$superMessage('提示', e)
        })
      },
      /**
       * 获取责任险信息
       * @author wanghongling
       * @createTime 2019/06/20
       */
      getInsuranceInfo (orgId) {
        return this.$request.pcInsuranceListGet({orgId: orgId}).then(res => {
          console.log('获取责任险信息', res)
          if (!this.$utils.isEmptyObject(res)) {
            let arry
            res.map(val => {
              val.fileId.map(v => {
                arry = {
                  name: val.insuranceName,
                  fileId: v
                }
                console.log('arry*************', arry)
                this.tmpPicList.push(arry)
              })
            })
            this.resInfo.insuranceInfo = res
          }
        }).catch(e => {
          console.error(e)
          // this.$superMessage('提示', e)
        })
      },
      /**
       * @Description:获取营业执照信息
       * @author wanghongling
       * @param orgId 承包商id
       * @createDate 2019/10/17
       */
      getBusinesslicense (orgId) {
        return this.$request.pcBusinesslicenseDetailGet({orgId: orgId}).then(res => {
          console.log('获取营业执照信息', res)
          if (!this.$utils.isEmptyObject(res)) {
            let arry = {
              name: '营业执照',
              fileId: res.fileId[0]
            }
            this.tmpPicList.push(arry)
            this.resInfo.businesslicense = res
          }
        }).catch(e => {
          console.error(e)
          // this.$superMessage('提示', e)
        })
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  @import '../../assets/less/color';

  .relevant-zz {
    font-size: 14px;
    color: @lightBlue;
    margin-top: 5px;

    .title {
      height: 35px;
    }

    .pic {
      margin: 5px auto;
      height: 77px;
      overflow: hidden;
      cursor: pointer;

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .pic1{
      height: 100px !important;
    }

    .zz-pop {
      position: absolute;
      left: 450px;
      top: 145px;
      z-index: 1;
    }

    .el-carousel--horizontal {
      margin-bottom: -20px;
    }

    .el-carousel__container {
      height: 115px;
    }

    .el-carousel__button {
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }

    .el-carousel__indicators--outside button {
      background-color: #000;
      opacity: 1;
    }

    .el-carousel__indicator.is-active button {
      background-color: #0a8b9c;
    }

    .el-carousel__indicator--horizontal {
      padding: 6px 4px;
    }

    .el-carousel__indicators--outside {
      margin-top: -20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shitang/zzYC.vue